import React, { Component } from 'react';
import IteamChooseColorMenuComponent from '../components/IteamChooseColorMenuComponent';
import IteamChoosePenMenuComponent from '../components/IteamChoosePenMenuComponent';
import IteamChooseMarkerMenuComponent from '../components/IteamChooseMarkerMenuComponent';
import IteamChooseEraserMenuComponent from '../components/IteamChooseEraserMenuComponent';

import { ColorsDM, iteamColorModelInstance, ITeamModes, iteamWorkingModeInstance } from '../datamodel/datamodel';


class IteamToolbarContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {mode: ITeamModes.interaction,
                        isChooseColorMenuShown: false,
                        isChoosePenMenuShown: false,
                        isChooseMarkerMenuShown: false,
                        isChooseEraserMenuShown: false,
                        currentDrawingSize: 'small',
                        currentcolor: ColorsDM.navy};

        this.switchToInteractionMode = this.switchToInteractionMode.bind(this);
        this.switchToPenMode = this.switchToPenMode.bind(this);
        this.switchToMarkerMode = this.switchToMarkerMode.bind(this);
        this.switchToEraserMode = this.switchToEraserMode.bind(this);

        this.showChooseColorMenu = this.showChooseColorMenu.bind(this);
        this.setCurrentColor = this.setCurrentColor.bind(this);

        this.showChoosePenMenu = this.showChoosePenMenu.bind(this);
        this.hideChoosePenMenu = this.hideChoosePenMenu.bind(this);
        this.showChooseMarkerMenu = this.showChooseMarkerMenu.bind(this);
        this.hideChooseMarkerMenu = this.hideChooseMarkerMenu.bind(this);
        this.showChooseEraserMenu = this.showChooseEraserMenu.bind(this);
        this.hideChooseEraserMenu = this.hideChooseEraserMenu.bind(this);
        this.setCurrentDrawingSize = this.setCurrentDrawingSize.bind(this);
        
        this.zoomInHandler = this.zoomInHandler.bind(this);
        this.zoomOutHandler = this.zoomOutHandler.bind(this);
        this.zoomFitWidthHandle = this.zoomFitWidthHandle.bind(this);
        this.zoomFitHeightHandler = this.zoomFitHeightHandler.bind(this);

        this.closeAllDrawingThicknessMenus = this.closeAllDrawingThicknessMenus.bind(this);


        this.interactionBtn = React.createRef();
        this.chooseColorBtn = React.createRef();
        this.choosePenBtn = React.createRef();
        this.chooseMarkerBtn = React.createRef();
        this.chooseEraserBtn = React.createRef();


    }

    componentDidMount() {
        if (this.props.setCloseDrawingThicknessMenuHandler !== undefined && this.props.setCloseDrawingThicknessMenuHandler !== null) {
            this.props.setCloseDrawingThicknessMenuHandler(this.closeAllDrawingThicknessMenus);
        }
    }


    closeAllDrawingThicknessMenus() {
        this.hideChoosePenMenu();
        this.hideChooseMarkerMenu();
        this.hideChooseEraserMenu();
    }

    switchToInteractionMode() {
        this.setState({isChooseColorMenuShown: false});
        this.setState({isChoosePenMenuShown: false});
        this.setState({isChooseMarkerMenuShown: false});
        this.setState({isChooseEraserMenuShown: false});

        iteamWorkingModeInstance.setMode(ITeamModes.interaction);
        this.setState({mode: ITeamModes.interaction});
    }

    switchToPenMode() {
        iteamWorkingModeInstance.setMode(ITeamModes.pen);
        this.setState({mode: ITeamModes.pen});
        this.showChoosePenMenu();
    }

    switchToMarkerMode() {
        iteamWorkingModeInstance.setMode(ITeamModes.marker);
        this.setState({mode: ITeamModes.marker});
        this.showChooseMarkerMenu();
    }

    switchToEraserMode() {
        iteamWorkingModeInstance.setMode(ITeamModes.eraser);
        this.setState({mode: ITeamModes.eraser});
        this.showChooseEraserMenu();
    }

    showChooseColorMenu() {
        if (this.state.isChooseColorMenuShown) {
            this.setState({isChooseColorMenuShown: false});
        } else {
            this.setState({isChooseColorMenuShown: true});
            this.setState({isChoosePenMenuShown: false});
            this.setState({isChooseMarkerMenuShown: false});
            this.setState({isChooseEraserMenuShown: false});            
        }
    }

    showChoosePenMenu() {
        if (this.state.isChoosePenMenuShown) {
            this.setState({isChoosePenMenuShown: false});
        } else {
            this.setState({isChooseColorMenuShown: false});
            this.setState({isChoosePenMenuShown: true});
            this.setState({isChooseMarkerMenuShown: false});
            this.setState({isChooseEraserMenuShown: false});  
        }
    }

    hideChoosePenMenu() {
        this.setState({isChoosePenMenuShown: false});
    }

    showChooseMarkerMenu() {
        if (this.state.isChooseMarkerMenuShown) {
            this.setState({isChooseMarkerMenuShown: false});
        } else {
            this.setState({isChooseColorMenuShown: false});
            this.setState({isChoosePenMenuShown: false});
            this.setState({isChooseMarkerMenuShown: true});
            this.setState({isChooseEraserMenuShown: false});
        }
    }

    hideChooseMarkerMenu() {
        this.setState({isChooseMarkerMenuShown: false});
    }

    showChooseEraserMenu() {
        if (this.state.isChooseEraserMenuShown) {
            this.setState({isChooseEraserMenuShown: false});
        } else {
            this.setState({isChooseColorMenuShown: false});
            this.setState({isChoosePenMenuShown: false});
            this.setState({isChooseMarkerMenuShown: false});
            this.setState({isChooseEraserMenuShown: true});
        }
    }

    hideChooseEraserMenu() {
        this.setState({isChooseEraserMenuShown: false});
    }

    setCurrentColor(color) {
        iteamColorModelInstance.setColor(color);
        this.setState({currentcolor: color});
    }

    setCurrentDrawingSize(drawingSize) {
        this.setState({currentDrawingSize: drawingSize});
    }


    zoomInHandler() {
        if (this.state.isChooseColorMenuShown) {
            this.setState({isChooseColorMenuShown: false});
        }
        if (this.props.isExerciseModeActive) {
            this.props.zoomInExerciseHandler();
        } else {
            this.props.zoomInPageHandler();
        }
    }

    zoomOutHandler() {
        if (this.state.isChooseColorMenuShown) {
            this.setState({isChooseColorMenuShown: false});
        }
        if (this.props.isExerciseModeActive) {
            this.props.zoomOutExerciseHandler();
        } else {
            this.props.zoomOutPageHandler();
        }
    }

    zoomFitWidthHandle() {
        if (this.state.isChooseColorMenuShown) {
            this.setState({isChooseColorMenuShown: false});
        }
        if (this.props.isExerciseModeActive) {
            this.props.zoomFitWidthExerciseHandler();
        } else {
            this.props.zoomFitWidthPageHandler();
        }
    }

    zoomFitHeightHandler() {
        if (this.state.isChooseColorMenuShown) {
            this.setState({isChooseColorMenuShown: false});
        }
        if (this.props.isExerciseModeActive) {
            this.props.zoomFitHeightExerciseHandler();
        } else {
            this.props.zoomFitHeightPageHandler();
        }
    }

    render() {
        let chooseColorMenuComponent = '';
        if (this.state.isChooseColorMenuShown) {
            chooseColorMenuComponent = (<IteamChooseColorMenuComponent 
                                            showChooseColorMenu={this.showChooseColorMenu}
                                            chooseColorBtnTop={this.chooseColorBtn.current.offsetTop}
                                            chooseColorBtnHeight={this.chooseColorBtn.current.offsetHeight}
                                            setCurrentColor={this.setCurrentColor}
                                            disableGameInputsCallback={this.props.disableGameInputsCallback}
                                            enableGameInputsCallback={this.props.enableGameInputsCallback}
                    
            />);
        }

        let choosePenMenuComponent = '';
        if (this.state.isChoosePenMenuShown) {
            choosePenMenuComponent = (<IteamChoosePenMenuComponent 
                showChoosePenMenu={this.showChoosePenMenu}
                choosePenBtnTop={this.choosePenBtn.current.offsetTop}
                choosePenBtnHeight={this.choosePenBtn.current.offsetHeight}
                setCurrentDrawingSize={this.setCurrentDrawingSize}

            />);
        }

        let chooseMarkerMenuComponent = '';
        if (this.state.isChooseMarkerMenuShown) {
            chooseMarkerMenuComponent = (<IteamChooseMarkerMenuComponent 
                showChooseMarkerMenu={this.showChooseMarkerMenu}
                chooseMarkerBtnTop={this.chooseMarkerBtn.current.offsetTop}
                chooseMarkerBtnHeight={this.chooseMarkerBtn.current.offsetHeight}
                setCurrentDrawingSize={this.setCurrentDrawingSize}

            />);
        }

        let chooseEraserMenuComponent = '';
        if (this.state.isChooseEraserMenuShown) {
            chooseEraserMenuComponent = (<IteamChooseEraserMenuComponent 
                showChooseEraserMenu={this.showChooseEraserMenu}
                chooseEraserBtnTop={this.chooseEraserBtn.current.offsetTop}
                chooseEraserBtnHeight={this.chooseEraserBtn.current.offsetHeight}
                setCurrentDrawingSize={this.setCurrentDrawingSize}
            />);
        }


        return (
            <div id='iTeamToolbarContainer' className='iTeamToolbarContainer'>
                <div className='iTeamModeIndicatorBar rightBottomRadius'>
                    <div className="rotated">
                        <span className='iTeamModeIndicatorFont'>{this.state.mode}</span>
                    </div>
                </div>
                <div id='iTeamToolbarSpace' className='iTeamToolbarSpace'>
                </div>
                <div className='iTeamToolbar rightUpperRadius'>
                    <div className='iTeamBtnToolbarPageContainer iTeamToolbarBtnContainer spacerVertical'>
                        &nbsp;
                    </div>
                    <div className='iTeamBtnToolbarPageContainer iTeamToolbarBtnContainer marginBottom'>
                        <button className='btnToolbar' ref={this.interactionBtn}
                            onClick={this.switchToInteractionMode}>
                            <svg viewBox="0 0 200 200"><path id="hand" d="M165.65,49.41c0,.12,0,.25,0,.37V72.19c0,35.76-5.42,53.38-14.78,71.72-4.19,8.2-11.21,24.4-11.21,40.88v5.86H56V172.78c0-17.13-5.28-27.11-10.39-36.77-6.74-12.75-13.73-25.94-10.46-58.72,1.41-14.09,4.53-22.82,9.32-26.06v36.6a4.66,4.66,0,1,0,9.31,0V34.58c0-5.75,3-11.89,11.39-11.89,6.4,0,10.28,1.5,10.28,22.25V70.28a4.66,4.66,0,1,0,9.32,0v-49c0-5.74,3-11.88,11.4-11.88,6.88,0,11.39,1.47,11.39,21.2V70.28a4.66,4.66,0,1,0,9.31,0V29c0-5.74,3-11.88,11.4-11.88,6,0,10.31,1.09,11.21,15.17,0,.69.07,5,.1,10.54a23.28,23.28,0,0,0,0,5.38c0,9.3,0,19.65,0,22.08a4.66,4.66,0,1,0,9.32,0v-22a5.49,5.49,0,0,0-.05-.7c0-1.4,0-2.78,0-4.11a8.28,8.28,0,0,1,1.66-4.18c1.37-1.63,3.74-2.45,7.06-2.45,3,0,4.43,1.12,5.21,2,2.73,2.94,3,8.7,2.83,10.65m-8-22a20.89,20.89,0,0,0-9,1.84c-1-10.5-4.7-21.54-20.32-21.54a20.79,20.79,0,0,0-13.61,4.7C112.11,5.07,106.84,0,96.16,0,85.68,0,77.92,6.45,76,16.2a19.16,19.16,0,0,0-10.79-2.86c-12.19,0-20.7,8.73-20.7,21.24V41C34.19,43.66,28,55.52,25.87,76.36c-3.55,35.59,4.44,50.7,11.5,64,5,9.44,9.3,17.59,9.3,32.39v22.55A4.67,4.67,0,0,0,51.33,200h93a4.66,4.66,0,0,0,4.66-4.67V184.79c0-14.52,6.38-29.17,10.18-36.62,10-19.61,15.82-38.33,15.82-76V49.94c.11-1.82.41-11.34-5.28-17.5a15.88,15.88,0,0,0-12.07-5"/></svg>
                        </button>
                    </div>
                    <div className='iTeamBtnToolbarPageContainer iTeamToolbarBtnContainer topBorder paddingTop'>
                        <button className='btnToolbar' ref={this.chooseColorBtn}
                            onClick={this.showChooseColorMenu}>
                            <svg style={{fill: this.state.currentcolor.colorcodehtml}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M196.48,53.54c-10.14-31.24-40-52.22-76-53.47C119.05,0,117.6,0,116.16,0,52.11,0,0,49.44,0,110.19a107,107,0,0,0,28.25,72.06C38.56,193.55,54,200,70.17,200c1.57,0,3.14-.05,4.73-.17,18.1-1.42,34.17-10.7,43-24.83l1.72-2.77a70.54,70.54,0,0,1,23-22.52l20.6-12.59C193.82,118.39,206.87,85.59,196.48,53.54Zm-81-28.76c6,0,11,4.4,11,9.79s-4.91,9.8-11,9.8-11-4.4-11-9.8S109.44,24.78,115.48,24.78ZM41,102.84c-6,0-10.94-4.38-10.94-9.78S35,83.27,41,83.27s11,4.39,11,9.79S47,102.84,41,102.84ZM57.12,52.73c0-5.4,4.91-9.8,10.95-9.8s11,4.4,11,9.8-4.91,9.79-11,9.79S57.12,58.12,57.12,52.73ZM111,146.32l-2.38,2.11c-6.53,5.84-14.9,9.3-22.39,9.3a18.28,18.28,0,0,1-12.43-4.3c-8.67-7.75-2.56-31.85,7.85-41.14,3.55-3.19,8.7-4.87,14.85-4.87,10.68,0,23.59,5.14,29,10a8.41,8.41,0,0,1,3,6.41C128.45,130.94,119.6,138.76,111,146.32Zm45.09-79.77c-6,0-11-4.39-11-9.79s4.91-9.8,11-9.8,10.95,4.4,10.95,9.8S162.15,66.55,156.12,66.55Z"/><polygon points="176 199.97 176 200 200 200 200 176 199.97 176 176 199.97"/></svg>
                        </button>
                    </div>
                    <div className='iTeamBtnToolbarPageContainer iTeamToolbarBtnContainer'>
                        <button className='btnToolbar' ref={this.choosePenBtn}
                            onPointerDown={this.switchToPenMode}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M38.91,136.22a4.7,4.7,0,0,1-6.63,0l-7.77-7.77a4.68,4.68,0,0,1,0-6.62L126.83,19.5a4.69,4.69,0,0,1,6.63,0l7.76,7.77a4.68,4.68,0,0,1,0,6.62Z"/><path d="M58.54,155.85a4.69,4.69,0,0,1-6.63,0l-7.76-7.76a4.69,4.69,0,0,1,0-6.63L146.47,39.14a4.69,4.69,0,0,1,6.63,0l7.76,7.76a4.7,4.7,0,0,1,0,6.64Z"/><path d="M78.18,175.49a4.69,4.69,0,0,1-6.63,0l-7.76-7.76a4.7,4.7,0,0,1,0-6.64L166.1,58.78a4.67,4.67,0,0,1,6.63,0l7.76,7.76a4.67,4.67,0,0,1,0,6.63Z"/><polygon points="33.54 192.39 66.72 184.86 14.1 132.24 6.95 165.79 33.54 192.39"/><polygon points="0 200 23.14 194.75 4.82 176.87 0 200"/><path d="M189.05,64.62l4.54-4.54a21.88,21.88,0,0,0,0-30.95L170.87,6.4a21.92,21.92,0,0,0-31,0L135.38,11Z"/><polygon points="176 199.97 176 200 200 200 200 176 199.97 176 176 199.97"/></svg>
                        </button>
                    </div>
                    <div className='iTeamBtnToolbarPageContainer iTeamToolbarBtnContainer'>
                        <button className='btnToolbar' ref={this.chooseMarkerBtn}
                            onPointerDown={this.switchToMarkerMode}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M195.36,36.91,166.13,5.22A15.8,15.8,0,0,0,143,4.9L120.83,27.66l52.09,56.48,22.13-22.76A18,18,0,0,0,195.36,36.91Z"/><path d="M36.57,114.31a15.66,15.66,0,0,0-2.35,18.35,15,15,0,0,0,2.09,2.89L68.54,170.5a14.85,14.85,0,0,0,2.68,2.28,13.65,13.65,0,0,0,17.44-2L167,90.25,114.89,33.77Z"/><path d="M30.93,147.59A45.57,45.57,0,0,1,18.67,172.2l-1.24,1.27,14.72,15.95,1.23-1.27A43.33,43.33,0,0,1,44.26,180,40.94,40.94,0,0,1,57,175.88a35.79,35.79,0,0,0,4.08-.9L31.87,143.29A38.7,38.7,0,0,0,30.93,147.59Z"/><polygon points="0 194.42 18.92 200 24.77 193.98 12.93 181.13 0 194.42"/><polygon points="176 199.97 176 200 200 200 200 176 199.97 176 176 199.97"/></svg>
                        </button>
                    </div>
                    <div className='iTeamBtnToolbarPageContainer iTeamToolbarBtnContainer marginBottom'>
                        <button className='btnToolbar' ref={this.chooseEraserBtn}
                            onPointerDown={this.switchToEraserMode}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M182.41,77.36l-46.19,46.18L76.45,63.78l46.19-46.19a7.8,7.8,0,0,1,10.87,0l48.9,48.9a7.8,7.8,0,0,1,0,10.87M74.65,190.56,9.44,125.36l5.44-5.44,65.2,65.2ZM193.27,55.62l-48.9-48.9a23.13,23.13,0,0,0-32.6,0L6.72,111.77a23.13,23.13,0,0,0,0,32.6l48.9,48.9a23.13,23.13,0,0,0,32.61,0l105-105a23.12,23.12,0,0,0,0-32.61"/><polygon points="176 199.97 176 200 200 200 200 176 199.97 176 176 199.97"/></svg>
                        </button>
                    </div>
                    <div className='iTeamBtnToolbarPageContainer iTeamToolbarBtnContainer topBorder paddingTop'>
                        <button className='btnToolbar'
                            onClick={this.zoomInHandler}>
                            <svg viewBox="0 0 200 200"><path d="M163.73,36.27a60.11,60.11,0,1,0,0,85,60.19,60.19,0,0,0,0-85M65.5,134.51a78.81,78.81,0,1,1,111.46,0,78.9,78.9,0,0,1-111.46,0"/><path d="M35.4,191.22l44.7-55.34-8-8-8-8L8.78,164.6a18.79,18.79,0,0,0-3.14,2.54,19.25,19.25,0,0,0,27.22,27.22,18.79,18.79,0,0,0,2.54-3.14"/><rect x="108.58" y="36.85" width="25.21" height="86.48" rx="9.34"/><rect x="108.58" y="36.85" width="25.21" height="86.48" rx="9.34" transform="matrix(0, 1, -1, 0, 201.28, -41.09)"/></svg>
                        </button>
                    </div>
                    <div className='iTeamBtnToolbarPageContainer iTeamToolbarBtnContainer marginBottom'>
                        <button className='btnToolbar'
                            onClick={this.zoomOutHandler}>
                            <svg viewBox="0 0 200 200"><path d="M163.73,36.27a60.11,60.11,0,1,0,0,85,60.19,60.19,0,0,0,0-85M65.5,134.51a78.81,78.81,0,1,1,111.46,0,78.9,78.9,0,0,1-111.46,0"/><path d="M35.4,191.22l44.7-55.34-8-8-8-8L8.78,164.6a18.79,18.79,0,0,0-3.14,2.54,19.25,19.25,0,0,0,27.22,27.22,18.79,18.79,0,0,0,2.54-3.14"/><rect x="108.58" y="36.85" width="25.21" height="86.48" rx="9.34" transform="translate(201.28 -41.09) rotate(90)"/></svg>
                        </button>
                    </div>
                    <div className='iTeamBtnToolbarPageContainer iTeamToolbarBtnContainer topBorder paddingTop'>
                        <button className='btnToolbar'
                            onClick={this.zoomFitWidthHandle}>
                            <svg viewBox="0 0 200 200"><path d="M200,194v-9.72H0V194s0,1.53,9.57,2.47L24.79,200H176l15.22-3.49c9.58-.94,8.77-2.47,8.77-2.47"/><path d="M170.45,161.23H29.3V20.78H170.45ZM195.5,4.54A4.55,4.55,0,0,0,191,0H8.79A4.54,4.54,0,0,0,4.25,4.54V180H195.5Z"/><polygon points="166.59 90.57 138.78 114.72 138.78 66.42 166.59 90.57"/><polygon points="33.11 90.57 60.91 114.72 60.91 66.42 33.11 90.57"/></svg>
                        </button>
                    </div>
                    <div className='iTeamBtnToolbarPageContainer iTeamToolbarBtnContainer'>
                        <button className='btnToolbar'
                            onClick={this.zoomFitHeightHandler}>
                            <svg viewBox="0 0 200 200"><path d="M200,194v-9.72H0V194s0,1.53,9.57,2.47L24.79,200H176l15.22-3.49c9.58-.94,8.77-2.47,8.77-2.47"/><path d="M170.45,161.23H29.3V20.78H170.45ZM195.5,4.54A4.55,4.55,0,0,0,191,0H8.79A4.54,4.54,0,0,0,4.25,4.54V180H195.5Z"/><polygon points="99.85 157.29 75.7 129.49 124 129.49 99.85 157.29"/><polygon points="99.85 23.84 75.7 51.65 124 51.65 99.85 23.84"/></svg>
                        </button>
                    </div>
                </div>
                {chooseColorMenuComponent}
                {choosePenMenuComponent}
                {chooseMarkerMenuComponent}
                {chooseEraserMenuComponent}
            </div>
        );
    }
}


export default IteamToolbarContainer;
